<template>
  <v-text-field
    v-model="text"
    :label="title"
    hide-details
    dense
    append-icon="search"
    class="search-input"
    outlined
    :clearable="clearable"
    :placeholder="placeholder"
    :data-test="dataTest"
    v-on="$listeners"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    title: {
      type: String,
      default: "Пошук",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    dataTest: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    text: "",
  }),
  watch: {
    text(val) {
      this.$emit("input", val);
    },
    value: {
      handler(val) {
        this.text = val;
      },
      immediate: true,
    },
  },
};
</script>
<style>
.search-input.v-text-field label {
  color: #adadad;
}
</style>
